import { Module } from 'wrapper6';

export default class Scrollmenu extends Module {
  ready() {
    this.scrollDistance = 50;
    this.lastKnownScrollY = 0;
    this.ticking = false;

    this.barElem = document.getElementsByClassName('topmenubar')[0];
    this.navElem = document.getElementsByClassName('navigation')[0];
    this.bodyElem = document.body;

    this.addListeners();
    this.onScroll();
  }

  addListeners() {
    window.addEventListener('scroll', () => this.onScroll(), false);
  }

  onScroll() {
    this.lastKnownScrollY = window.pageYOffset;
    this.requestTick();
  }

  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
    }

    this.ticking = true;
  }

  update() {
    let currentScrollY = this.lastKnownScrollY;

    this.ticking = false;
    this.checkScrollDistance(currentScrollY);
  }

  checkScrollDistance(scrolledDistance) {
    if (this.scrollDistance < 1) {
      return false;
    }

    if (scrolledDistance > this.scrollDistance) {
      this.bodyElem.classList.add('scrolled');
      this.barElem ? this.barElem.classList.add('scrolled') : this.navElem.classList.add('scrolled');
    } else if (scrolledDistance < this.scrollDistance) {
      this.bodyElem.classList.remove('scrolled');

      if (this.barElem) {
        this.barElem.classList.remove('scrolled');
      }

      if (this.navElem) {
        this.navElem.classList.remove('scrolled');
      }
    }
  }
}